<app-pattern [formControl]="patternControl" [options]="patternOptions"></app-pattern>

<h2>OLD</h2>
<div>
  <h3>Simple</h3>
  <div class="d-flex flex-column">
    <div class="row m-0">
      <div class="col-8">
        <vitamui-common-editable-input [formControl]="streetEmpty" [label]="'Editable input'"></vitamui-common-editable-input>
      </div>
      <vitamui-common-editable-input [disabled]="true" [formControl]="streetDisable" [label]="'Editable input disabled'">
      </vitamui-common-editable-input>
    </div>
  </div>
  <h3>Email</h3>
  <div class="d-flex flex-column">
    <div class="row m-0 pl-3 mt-4">
      <vitamui-input class="field-email" [formControl]="emailFirstPart" placeholder="Adresse e-mail"></vitamui-input>

      <span class="d-flex mx-2 mt-1 layer text-center">&#64;</span>

      <mat-form-field class="field-domain vitamui-mat-select">
        <mat-select [formControl]="domain" panelClass="vitamui-mat-select">
          <mat-option value="test.fr">test.fr</mat-option>
          <mat-option value="test2.com">test2.com</mat-option>
        </mat-select>
        <div class="select-arrow">
          <i class="material-icons">keyboard_arrow_up</i>
          <i class="material-icons">keyboard_arrow_down</i>
        </div>
      </mat-form-field>
    </div>
    <div class="row m-0">
      <div class="col-8">
        <vitamui-common-editable-email-input
          [formControl]="email"
          [label]="'Editable email'"
          [domains]="['test.fr', 'test.com', 'test.de']"
        ></vitamui-common-editable-email-input>
      </div>
      <vitamui-common-editable-email-input
        [formControl]="email"
        [label]="'Editable email disabled'"
        [domains]="['test.fr', 'test.com', 'test.de']"
        [disabled]="true"
      ></vitamui-common-editable-email-input>
    </div>
  </div>

  <h3>Editable patterns</h3>
  <div class="d-flex flex-column">
    <div class="row m-0 pl-3 pr-3 mt-4">
      <app-editable-patterns [formControl]="editablePatterns" label="Editable patterns" [options]="editablePatternsOptions">
      </app-editable-patterns>
    </div>
  </div>

  <div class="d-flex flex-column">
    <h3>Select</h3>
    <div class="d-flex flex-column">
      <div class="row m-0 mt-4">
        <div class="col-8">
          <mat-form-field class="mr-3 field-domain vitamui-mat-select">
            <mat-select [formControl]="country" panelClass="vitamui-mat-select">
              @for (country of countries; track country) {
                <mat-option [value]="country.key">
                  {{ country.label }}
                </mat-option>
              }
            </mat-select>
            <div class="select-arrow">
              <i class="material-icons">keyboard_arrow_up</i>
              <i class="material-icons">keyboard_arrow_down</i>
            </div>
          </mat-form-field>
        </div>
        <mat-form-field class="mr-3 field-domain vitamui-mat-select">
          <mat-select [formControl]="country" [disabled]="true" panelClass="vitamui-mat-select">
            @for (country of countries; track country) {
              <mat-option [value]="country.key">
                {{ country.label }}
              </mat-option>
            }
          </mat-select>
          <div class="select-arrow">
            <i class="material-icons">keyboard_arrow_up</i>
            <i class="material-icons">keyboard_arrow_down</i>
          </div>
        </mat-form-field>
      </div>
    </div>

    <h3>{{ 'INPUT.TEXTAREA' | translate }}</h3>
    <div class="d-flex flex-column">
      <div class="row m-0 mt-4">
        <div class="col-8">
          <vitamui-common-editable-textarea [formControl]="textarea" [label]="'Editable textarea'"></vitamui-common-editable-textarea>
        </div>
        <vitamui-common-editable-textarea [formControl]="textarea" [label]="'Editable textarea disabled'" [disabled]="true">
        </vitamui-common-editable-textarea>
      </div>
    </div>

    <h3>{{ 'INPUT.LEVEL' | translate }}</h3>
    <div class="d-flex flex-column">
      <div class="row m-0 mt-4 pl-3">
        <vitamui-common-level-input></vitamui-common-level-input>
      </div>
      <div class="row m-0">
        <div class="col-8">
          <vitamui-common-editable-level-input [label]="'Editable level input'"></vitamui-common-editable-level-input>
        </div>
        <vitamui-common-editable-level-input [formControl]="level" [label]="'Editable level input disabled'" [disabled]="true">
        </vitamui-common-editable-level-input>
      </div>
    </div>
    <h3>Toggle</h3>
    <div class="row m-0">
      <div class="col-12 mt-4">
        <vitamui-slide-toggle class="mr-3">Slide Toggle Off</vitamui-slide-toggle>
        <vitamui-slide-toggle [checked]="false" [disabled]="true" class="mr-3">Slide Toggle Off disabled </vitamui-slide-toggle>
        <vitamui-slide-toggle [checked]="true" class="mr-3">Slide Toggle On</vitamui-slide-toggle>
        <vitamui-slide-toggle [checked]="true" [disabled]="true" class="mr-3">Slide Toggle On disabled </vitamui-slide-toggle>
      </div>
    </div>
    <h3>Toggle Group</h3>
    <div class="d-flex flex-column">
      <div class="row m-0 mt-4 pl-3">
        <mat-button-toggle-group [formControl]="control" class="vitamui-button-toggle-group mr-4">
          <mat-button-toggle [value]="'FIRST'">
            <span>First</span>
          </mat-button-toggle>
          <mat-button-toggle [value]="'MIDDLE'">
            <span>Middle</span>
          </mat-button-toggle>
          <mat-button-toggle [value]="'LAST'">
            <span>Last</span>
          </mat-button-toggle>
        </mat-button-toggle-group>

        <mat-button-toggle-group [formControl]="control" class="vitamui-button-toggle-group disabled" [disabled]="true">
          <mat-button-toggle [value]="'FIRST'">
            <span>First</span>
          </mat-button-toggle>
          <mat-button-toggle [value]="'MIDDLE'">
            <span>Middle</span>
          </mat-button-toggle>
          <mat-button-toggle [value]="'LAST'">
            <span>Last</span>
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      <div class="row m-0">
        <div class="col-8 mt-4">
          <vitamui-common-editable-toggle-group [formControl]="toggle" [label]="'Editable toggle Group'">
            <vitamui-common-editable-button-toggle value="Value 1" content="Label 1"></vitamui-common-editable-button-toggle>
            <vitamui-common-editable-button-toggle value="Value 2" content="Label 2"></vitamui-common-editable-button-toggle>
            <vitamui-common-editable-button-toggle value="Value 3" content="Label 3"></vitamui-common-editable-button-toggle>
          </vitamui-common-editable-toggle-group>
        </div>
        <div class="mt-4">
          <vitamui-common-editable-toggle-group [formControl]="toggle" [label]="'Editable toggle Group disabled'" [disabled]="true">
            <vitamui-common-editable-button-toggle value="Value 1" content="Label 1"></vitamui-common-editable-button-toggle>
            <vitamui-common-editable-button-toggle value="Value 2" content="Label 2"></vitamui-common-editable-button-toggle>
            <vitamui-common-editable-button-toggle value="Value 3" content="Label 3"></vitamui-common-editable-button-toggle>
          </vitamui-common-editable-toggle-group>
        </div>
      </div>
    </div>

    <h3>File</h3>
    <div class="row m-0">
      <div class="col-8 mt-4">
        <vitamui-common-editable-file [formControl]="file" [label]="'Editable file upload'"></vitamui-common-editable-file>
      </div>
      <div class="mt-4">
        <vitamui-common-editable-file [formControl]="file" [label]="'Editable file upload disabled'" [disabled]="true">
        </vitamui-common-editable-file>
      </div>
    </div>
  </div>
</div>
